
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/shiva",
      function () {
        return require("private-next-pages/mahashivratri/shiva/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/shiva"])
      });
    }
  